import PropTypes from 'prop-types';

/**
 * @typedef {object} InventoryWarehouse
 * @property {boolean} isActive
 * @property {string} createDate
 * @property {string} externalInventoryWarehouseGuid
 * @property {string} inventoryWarehouseId
 * @property {boolean} linkToDefault
 * @property {number} locationDimensions
 * @property {string} modifyDate
 * @property {string} name
 */

export const InventoryWarehousePropType = PropTypes.shape({
  isActive: PropTypes.bool,
  createDate: PropTypes.string,
  externalInventoryWarehouseGuid: PropTypes.string,
  inventoryWarehouseId: PropTypes.string,
  linkToDefault: PropTypes.bool,
  locationDimensions: PropTypes.number,
  modifyDate: PropTypes.string,
  name: PropTypes.string,
});
